import { Routes } from '@angular/router';

export const issuesRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/issues-list/issues-list.component').then(
        (m) => m.IssuesListComponent,
      ),
  },
  {
    path: ':id',
    data: { title: 'Issue', breadcrumb: 'Issue' },
    loadComponent: () =>
      import('./components/issue-detail/issue-detail.component').then(
        (m) => m.IssueDetailComponent,
      ),
  },
];
